/* eslint-disable prettier/prettier */
export class Message {
    constructor(messageCode, message) {
        this.messageCode = messageCode;
        this.message = message;
    }
    getMessage(params = []) {
        let message = this.message;
        if (params) {
            for (let i = 0; i < params.length; i++) {
                let param = params[i];
                if (typeof param !== "string") {
                    param = param.toString();
                }
                message = message.replace(new RegExp(`\\{${i}\\}`, "g"), param);
            }
        }
        return message;
    }
}
